import { forwardRef, type Ref, type SVGProps } from "react";

export function CrossedBadgeIcon(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M0.19 0.19a.65.65 0 0 1 .92 0l2.06 2.06a.65.65 0 0 1 .144.144L19.11 18.19a.65.65 0 0 1-.92.92l-1.373-1.373a4.15 4.15 0 0 1-.667.063H3.65A3.65 3.65 0 0 1 0 14.15V5.65c0-1.285.665-2.412 1.668-3.062L.19 1.11a.65.65 0 0 1 0-.92Zm2.428 3.348A2.35 2.35 0 0 0 1.3 5.65v8.5A2.35 2.35 0 0 0 3.65 16.5h11.93l-6.28-6.28v2.43a1.65 1.65 0 0 1-1.65 1.65h-3.5a1.65 1.65 0 0 1-1.65-1.65v-6a1.65 1.65 0 0 1 1.583-1.647L2.618 3.538Zm13.532-1.538A3.65 3.65 0 0 1 19.8 5.65v8.5c0 .627-.16 1.22-.44 1.737a.65.65 0 0 1-.006.012.65.65 0 0 1-1.143-.623l.014-.027A2.34 2.34 0 0 0 18.5 14.15v-8.5A2.35 2.35 0 0 0 16.15 3.3H6.15a.65.65 0 0 1 0-1.3h10ZM4.15 6.3a.35.35 0 0 0-.35.35v6a.35.35 0 0 0 .35.35h3.5a.35.35 0 0 0 .35-.35V8.92L5.38 6.3H4.15Zm11.5 3.7a.65.65 0 0 1 .65.65.65.65 0 0 1-.65.65h-1.789a.65.65 0 0 1-.65-.65.65.65 0 0 1 .65-.65h1.789Zm1-3a.65.65 0 0 1 .65.65.65.65 0 0 1-.65.65H10.9a.65.65 0 0 1-.65-.65.65.65 0 0 1 .65-.65h5.75Z"
        clipRule="evenodd"
      />
    </svg>
  );
}

const ForwardRef = forwardRef(CrossedBadgeIcon);
export default ForwardRef;
